import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function PageHeader({ eyebrow, title, subtitle, breadcrumb }) {
  return (
    <div className="relative overflow-hidden bg-primary text-white">
      <div className="absolute inset-0 hero-grid opacity-50" />
      <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-amber-500/20 blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-6 py-12 md:py-16">
        {breadcrumb && (
          <div className="flex items-center gap-2 text-sm text-slate-400 mb-3">
            <Link to="/" className="hover:text-amber-400">Home</Link>
            <ChevronRight className="w-4 h-4" />
            <span className="text-slate-300">{breadcrumb}</span>
          </div>
        )}
        {eyebrow && <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-400 font-semibold mb-2">{eyebrow}</p>}
        <h1 className="font-serif font-black text-4xl md:text-5xl leading-tight">{title}</h1>
        {subtitle && <p className="mt-4 text-slate-300 max-w-2xl text-base md:text-lg">{subtitle}</p>}
      </div>
    </div>
  );
}
